import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const translationInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class TranslationApi {  

	static TranslationInsert(payload) {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return translationInstance.post('/translation', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static TranslationUpdate(payload, id) {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return translationInstance.patch(`/translation/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static TranslationList() {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return translationInstance.get('/translation')
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static TranslationDelete(id) {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return translationInstance.delete(`/translation/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static TranslationListChange(page, pageSize) {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return translationInstance.get(`/translation?page=${page}&perPage=${pageSize}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static TranslationSearch(title) {
		translationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return translationInstance.get(`/translation?title=${title}&perPage=100`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

}

export default TranslationApi; 


